const language = localStorage.getItem("language")
  ? localStorage.getItem("language")
  : "english";

export const langDir = "ltr";

export default language;
